<div class="flex flex-col gap-4 md:gap-6 rounded-md bg-shui-base-3 p-4 md:p-6 max-w-[900px]">
    <div class="flex flex-col gap-1 mb-2 md:mb-4">
        <h2 class="text-base md:text-lg font-semibold text-shui-text-strong p-0 m-0">
            {{ 'common.settings.user-settings.title' | translate }}
        </h2>
        <p class="text-xs md:text-sm text-shui-text-subtle p-0 m-0">
            {{ 'common.settings.user-settings.subtitle' | translate }}
        </p>
    </div>

    <div class="flex flex-col gap-6" [formGroup]="userSettingsForm()">
        <!-- E-Mail-Adresse ausblenden -->
        <div class="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4">
            <div class="flex flex-col gap-1">
                <span class="text-sm font-medium text-shui-text-strong">{{
                    'common.settings.user-settings.email-hiding.title' | translate
                }}</span>
                <span class="text-xs text-shui-text-subtle">{{
                    'common.settings.user-settings.email-hiding.description' | translate
                }}</span>
            </div>
            <sh-toggle-accessor
                data-testid="toggle-email-hiding"
                formControlName="emailHidingEnabled"
            ></sh-toggle-accessor>
        </div>

        <!-- Standardmäßige Einträge pro Seite -->
        <div class="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4">
            <div class="flex flex-col gap-1">
                <span class="text-sm font-medium text-shui-text-strong">{{
                    'common.settings.user-settings.page-size.title' | translate
                }}</span>
                <span class="text-xs text-shui-text-subtle">{{
                    'common.settings.user-settings.page-size.description' | translate
                }}</span>
            </div>
            <sh-select
                data-testid="select-default-page-size"
                formControlName="defaultPageSize"
                class="w-24"
                [condensed]="true"
                [options]="pageSizeOptions()"
            ></sh-select>
        </div>
    </div>
</div>
